import { render } from "./Editor.vue?vue&type=template&id=dd1701b6"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
script.render = render

export default script